import React from "react";
import {
  Search,
  ShieldCheck,
  BarChart3,
  Megaphone,
  Globe,
  Users,
  Swords,
  CalendarDays,
  FileText,
} from "lucide-react";
import NarrativeStrategyCardBase from "./NarrativeStrategyCardBase";
import {
  parseNarrativeStrategyBlock,
  normalizeNarrativeStrategyTitle,
} from "./narrativeStrategyUtils";

const FoundationalNarrativeStrategyRenderer = ({ markdown = "" }) => {
  const parsed = parseNarrativeStrategyBlock(markdown);
  if (!parsed) return null;

  const t = normalizeNarrativeStrategyTitle(parsed.title);

  let Icon = FileText;
  let subtitle = "Strategy direction and execution priorities";
  let titleOverride = "";

  if (t.includes("google search console strategy")) {
    Icon = Search;
    subtitle = "Indexing, visibility, and search engagement next steps";
  } else if (t.includes("google merchant center strategy")) {
    Icon = ShieldCheck;
    subtitle = "Trust, policy, and buyer confidence next steps";
  } else if (t.includes("benchmark strategy")) {
    Icon = BarChart3;
    titleOverride = "Shop Summary";
    subtitle = "Operational and conversion benchmark next steps";
  } else if (t.includes("meta report strategy")) {
    Icon = Megaphone;
    subtitle = "Paid social presence and activation next steps";
  } else if (t.includes("market analysis strategy")) {
    Icon = Globe;
    subtitle = "Market positioning and differentiation next steps";
  } else if (t.includes("target audience strategy")) {
    Icon = Users;
    subtitle = "Audience messaging and activation next steps";
  } else if (t.includes("competitor analysis strategy")) {
    Icon = Swords;
    subtitle = "Competitive response and visibility next steps";
  } else if (t.includes("content calendar strategy")) {
    Icon = CalendarDays;
    titleOverride = "Monthly Events Calendar";
    subtitle = "Seasonal planning and publishing next steps";
  }

  return (
    <NarrativeStrategyCardBase
      markdown={markdown}
      Icon={Icon}
      titleOverride={titleOverride}
      subtitle={subtitle}
    />
  );
};

export default FoundationalNarrativeStrategyRenderer;
